import { render, staticRenderFns } from "./BrokerGroupManager.vue?vue&type=template&id=6ddd826c&lang=pug"
import script from "./BrokerGroupManager.vue?vue&type=script&lang=js"
export * from "./BrokerGroupManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GroupSelect: require('/home/docker/code/frontend/components/GroupSelect.vue').default,Spinner: require('/home/docker/code/frontend/components/Spinner.vue').default})
